var Gifs = new (class Gifs extends AbstractModule {

  constructor() {
    super("Gifs");
    this._currentGifSearch = null;
  }

  display(what, query) {
    if (what == 'featured' || query == '') {
      this.showFeatured()
    } else {
      this.searchAndShow(query)
    }
  }

  showFeatured() {
    this._getEmojis('featured', (ajaxData) => {
      this.processGifsData(ajaxData)
    })
  }

  searchAndShow(query) {
    this._getEmojis(`searched:${query}`, (ajaxData) => {
      if (query == Dom.findById('widget', 'slaask-gifs-input').value) {
        this.processGifsData(ajaxData)
      }
    })
  }

  _getEmojis(cacheKey = 'featured', callback) {
    let storedSearchedGifs = Utils.sessionStorage(`gifs:${cacheKey}`)
    if (storedSearchedGifs) {
      this.processGifsData(storedSearchedGifs)
    } else {
      this.clearGifsList(true)
      Ajax.call(this._emojiUrl(cacheKey), {}, 'GET').then((ajaxData) => {
        Utils.sessionStorage(`gifs:${cacheKey}`, ajaxData)
        callback(ajaxData)
      })
    }
  }

  _emojiUrl(cacheKey) {
    let emojiUrl = `/api/gifs?language=${this.app._language}`

    if (cacheKey != 'featured') {
      emojiUrl = `${emojiUrl}&query=${cacheKey.split(':')[1]}`
    }

    return emojiUrl
  }

  processGifsData(ajaxData) {
    this.clearGifsList()
    if (ajaxData.length == 0) {
      this.showFeatured()
    } else {
      Utils.forEach(ajaxData, (gif) => {
        this.addGifToGifsContainer(gif)
      })
    }
  }

  addGifToGifsContainer(gif) {
    let gifElement = Dom.get('widget').document.createElement('div')
    gifElement.addEventListener('click', (event) => { this.onGifClick(event) })

    let media = gif.media[0]

    gifElement.className           = 'slaask-gif-element'
    gifElement.style['background'] = 'url(' + media.nanogif.url + ') center center / cover'

    gifElement.setAttribute('data-url', media.tinygif.url)

    Dom.findById('widget', 'slaask-gifs-subcontainer').appendChild(gifElement)
  }

  onGifClick(event) {
    Dom.findById('widget', 'slaask-input').value      = event.currentTarget.getAttribute('data-url')
    Dom.findById('widget', 'slaask-gifs-input').value = ''
    Conversations.submitOnlineForm()
    Dom.hideGifsContainer()
  }

  clearGifsList(withLoader = false) {
    Dom.findById('widget', 'slaask-gifs-subcontainer').innerHTML = withLoader ? Svg.loader() : ''
  }
});
